import { useTranslation } from 'react-i18next';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { refreshAccessToken } from '@avanta/shared/services/auth';
import { useAuthStore } from '@avanta/shared/stores/auth';
import { type AuthInfo } from '@avanta/shared/types/auth';
import { getRefreshToken } from '@avanta/shared/utils/storage';

let tokenPromise: Promise<string> | null = null;

export const useGetToken = (): string | null => {
  const token = useAuthStore(state => state.token());
  const authInfo = useAuthStore(state => state.authInfo);
  const setAuthInfo = useAuthStore(state => state.setAuthInfo);
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  if (token) return token;

  if (!tokenPromise) {
    const refreshToken = getRefreshToken();

    if (!refreshToken) {
      return null;
    }

    tokenPromise = refreshAccessToken(refreshToken)
      .then(newToken => {
        if (!newToken) throw new Error(t('Common.token.error'));
        setAuthInfo({
          ...(authInfo as AuthInfo),
          access_token: newToken,
        });
        tokenPromise = null;
        return newToken;
      })
      .catch(error => {
        tokenPromise = null;
        throw error;
      });
  }

  throw tokenPromise;
};
